"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationPreviewPage = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const PopupService_1 = __importStar(require("@front/services/PopupService"));
const component_1 = require("@front/components/site-menu/component");
const translations_1 = require("@front/application/globals/translations");
const trans_1 = require("../../../../../common/translations/trans");
//@ts-ignore                
let rwsTemplate = T.html `<div class="container-fluid">
  <div class="conversation-preview-page">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <div>
        <button class="btn btn-outline-secondary" @click="${x => x.goBack()}">
          <i class="simple-icon-arrow-left me-2"></i>
          ${'common.back'.t()}
        </button>
      </div>
      <div class="action-buttons">
        <button class="btn btn-primary" @click="${x => x.openInChat()}" ?disabled="${x => x.loading}">
          <i class="simple-icon-bubbles me-2"></i>
          ${'conversations.openInChat'.t()}
        </button>
        <button class="btn btn-danger" @click="${x => x.deleteConversation()}" ?disabled="${x => x.loading}">
          <i class="simple-icon-trash me-2"></i>
          ${'conversations.delete.action'.t()}
        </button>
      </div>
    </div>

    ${(0, fast_element_1.when)(x => x.loading, (0, fast_element_1.html) `
      <div class="loading-container text-center py-5">
        <div class="spinner-border" role="status">
          <span class="sr-only">${'common.loading'.t()}</span>
        </div>
        <div class="mt-2">${'conversations.loading'.t()}</div>
      </div>
    `)}

    ${(0, fast_element_1.when)(x => x.error && !x.loading, (0, fast_element_1.html) `
      <div class="alert alert-danger" role="alert">
        <i class="simple-icon-exclamation me-2"></i>
        ${x => x.error}
      </div>
    `)}

    ${(0, fast_element_1.when)(x => x.conversation && !x.loading && !x.error, (0, fast_element_1.html) `
      <div class="conversation-details card">
        <div class="card-header">
          <div class="d-flex justify-content-between align-items-start">
            <div>
              <h5 class="card-title mb-1">${x => { var _a; return (_a = x.conversation) === null || _a === void 0 ? void 0 : _a.title; }}</h5>
              <div class="text-muted">
                <small>
                  ${'conversations.lastActivity'.t()}: ${x => { var _a; return x.formatDate(((_a = x.conversation) === null || _a === void 0 ? void 0 : _a.lastActivity) || ''); }}
                </small>
              </div>
            </div>
            <div class="text-end">
              ${(0, fast_element_1.when)(x => { var _a; return (_a = x.conversation) === null || _a === void 0 ? void 0 : _a.model; }, (0, fast_element_1.html) `
                <span class="badge badge-info">${x => { var _a, _b, _c; return (_c = (_b = (_a = x.conversation) === null || _a === void 0 ? void 0 : _a.model) === null || _b === void 0 ? void 0 : _b.model) === null || _c === void 0 ? void 0 : _c.label; }}</span>
              `)}
            </div>
          </div>
        </div>
        
        <div class="card-body">
          ${(0, fast_element_1.when)(x => x.messages.length === 0, (0, fast_element_1.html) `
            <div class="no-messages text-center py-4">
              <div class="text-muted">
                <i class="simple-icon-bubbles" style="font-size: 2rem; opacity: 0.3;"></i>
                <p class="mt-2">${'conversations.noMessages'.t()}</p>
              </div>
            </div>
          `)}

          ${(0, fast_element_1.when)(x => x.messages.length > 0, (0, fast_element_1.html) `
            <div class="messages-container">
              ${(0, fast_element_1.repeat)(x => x.messages, (0, fast_element_1.html) `
                <div class="message-item ${x => x.fromUser ? 'user-message' : 'assistant-message'}">
                  <div class="message-header">
                    <div class="message-role">
                      <i class="${x => x.fromUser ? 'simple-icon-user' : 'simple-icon-robot'}"></i>
                      ${x => x.fromUser ? 'conversations.user'.t() : 'conversations.assistant'.t()}
                    </div>
                    <div class="message-time text-muted">
                      <small>${x => new Date(x.created_at).toLocaleString()}</small>
                    </div>
                  </div>
                  <div class="message-content">
                    <div :innerHTML="${x => x.fromUser ? x.content.replace(/\n/g, '<br>') : x.content}"></div>
                  </div>
                  ${(0, fast_element_1.when)(x => x.used_model, (0, fast_element_1.html) `
                    <div class="message-model text-muted mt-2">
                      <small><i class="simple-icon-settings me-1"></i>${x => x.used_model}</small>
                    </div>
                  `)}
                </div>
              `)}
            </div>
          `)}
        </div>
      </div>
    `)}
  </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `.conversation-preview-page .action-buttons {
  display: flex;
  gap: 0.5rem;
}
.conversation-preview-page .action-buttons .btn {
  display: flex;
  align-items: center;
}
.conversation-preview-page .loading-container {
  color: #6c757d;
}
.conversation-preview-page .conversation-details .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}
.conversation-preview-page .conversation-details .card-header .card-title {
  font-weight: 600;
  color: #495057;
}
.conversation-preview-page .conversation-details .messages-container {
  max-height: 70vh;
  overflow-y: auto;
}
.conversation-preview-page .conversation-details .messages-container .message-item {
  margin-bottom: 1.5rem;
  padding: 1rem;
  border-radius: 0.5rem;
  border: 1px solid #e9ecef;
}
.conversation-preview-page .conversation-details .messages-container .message-item.user-message {
  background-color: #e3f2fd;
  border-color: #bbdefb;
  margin-left: 2rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item.user-message .message-role {
  color: #1976d2;
  font-weight: 600;
}
.conversation-preview-page .conversation-details .messages-container .message-item.assistant-message {
  background-color: #f3e5f5;
  border-color: #ce93d8;
  margin-right: 2rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item.assistant-message .message-role {
  color: #7b1fa2;
  font-weight: 600;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-header {
  display: flex;
  justify-content: between;
  align-items: center;
  margin-bottom: 0.75rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-header .message-role {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.875rem;
  margin-right: 0.5rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-header .message-role i {
  font-size: 1rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-header .message-time {
  font-size: 0.75rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content {
  line-height: 1.6;
  color: #495057;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content h1, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h2, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h3, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h4, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h5, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h6 {
  margin-top: 1rem;
  margin-bottom: 0.5rem;
  font-weight: 600;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content h1:first-child, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h2:first-child, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h3:first-child, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h4:first-child, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h5:first-child, .conversation-preview-page .conversation-details .messages-container .message-item .message-content h6:first-child {
  margin-top: 0;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content h2 {
  color: #343a40;
  border-bottom: 2px solid #dee2e6;
  padding-bottom: 0.25rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content h3 {
  color: #495057;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content pre {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.25rem;
  padding: 0.75rem;
  overflow-x: auto;
  font-size: 0.875rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content code {
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  border-radius: 0.25rem;
  padding: 0.125rem 0.25rem;
  font-size: 0.875rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content blockquote {
  border-left: 4px solid #dee2e6;
  padding-left: 1rem;
  margin: 1rem 0;
  color: #6c757d;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content ul, .conversation-preview-page .conversation-details .messages-container .message-item .message-content ol {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content p {
  margin-bottom: 0.75rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-content p:last-child {
  margin-bottom: 0;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-model {
  font-size: 0.75rem;
}
.conversation-preview-page .conversation-details .messages-container .message-item .message-model i {
  opacity: 0.7;
}
.conversation-preview-page .no-messages i {
  display: block;
  margin-bottom: 0.5rem;
}
@media (max-width: 768px) {
  .conversation-preview-page .action-buttons {
    flex-direction: column;
  }
  .conversation-preview-page .action-buttons .btn {
    justify-content: center;
  }
  .conversation-preview-page .conversation-details .messages-container .message-item.user-message {
    margin-left: 0.5rem;
  }
  .conversation-preview-page .conversation-details .messages-container .message-item.assistant-message {
    margin-right: 0.5rem;
  }
}`;
const shadowOptions = { "mode": "open" };
let ConversationPreviewPage = class ConversationPreviewPage extends client_1.RWSViewComponent {
    constructor(popupService, notifyService) {
        super();
        this.popupService = popupService;
        this.notifyService = notifyService;
        this.conversation = null;
        this.messages = [];
        this.loading = false;
        this.error = null;
        this.conversationId = null;
    }
    async connectedCallback() {
        super.connectedCallback();
        this.conversationId = this.routeParams.conversationId;
        if (this.conversationId) {
            await this.loadConversation();
        }
    }
    async loadConversation() {
        if (!this.conversationId)
            return;
        this.loading = true;
        this.error = null;
        try {
            // Load conversation details with messages
            const conversationResponse = await this.apiService.back.get('conversation.get', {
                routeParams: { id: this.conversationId }
            });
            if (conversationResponse.success && conversationResponse.data) {
                this.conversation = conversationResponse.data;
                this.messages = conversationResponse.data.messages || [];
            }
            else {
                this.error = conversationResponse.error || 'conversations.failedToLoad'.t();
            }
        }
        catch (error) {
            console.error('Error loading conversation:', error);
            this.error = 'conversations.failedToLoad'.t();
        }
        finally {
            this.loading = false;
        }
    }
    goBack() {
        component_1.SiteMenu.goto.bind(this)('/conversation/list');
    }
    openInChat() {
        if (this.conversationId) {
            component_1.SiteMenu.goto.bind(this)(`/ai/chat?conversation=${this.conversationId}`);
        }
    }
    async deleteConversation() {
        if (!this.conversation)
            return;
        const confirmMessage = (0, trans_1.translate)('conversations.delete.confirm', (0, translations_1.getLanguage)() || 'en')
            .replace('{title}', this.conversation.title);
        const confirmed = await this.popupService.confirm(confirmMessage);
        if (!confirmed)
            return;
        try {
            const response = await this.apiService.back.delete('conversation.delete', {
                routeParams: { id: this.conversationId }
            });
            if (response.success) {
                this.notifyService.notify('conversations.delete.success'.t(), 'success');
                this.goBack();
            }
            else {
                this.notifyService.notify(response.error || 'conversations.delete.error'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Error deleting conversation:', error);
            this.notifyService.notify('conversations.delete.error'.t(), 'error');
        }
    }
    formatDate(date) {
        if (!date)
            return '-';
        return new Date(date).toLocaleString();
    }
    stripHtml(html) {
        var _a;
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;
        return ((_a = tempDiv.textContent) === null || _a === void 0 ? void 0 : _a.replace(/\s+/g, ' ').trim()) || '';
    }
};
exports.ConversationPreviewPage = ConversationPreviewPage;
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_c = typeof backendImport_1.IConversation !== "undefined" && backendImport_1.IConversation) === "function" ? _c : Object)
], ConversationPreviewPage.prototype, "conversation", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], ConversationPreviewPage.prototype, "messages", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], ConversationPreviewPage.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ConversationPreviewPage.prototype, "error", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], ConversationPreviewPage.prototype, "conversationId", void 0);
exports.ConversationPreviewPage = ConversationPreviewPage = __decorate([
    (0, client_1.RWSView)('conversation-preview-page', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __param(0, (0, client_1.RWSInject)(PopupService_1.default)),
    __param(1, (0, client_1.RWSInject)(client_1.NotifyService)),
    __metadata("design:paramtypes", [typeof (_a = typeof PopupService_1.PopupServiceInstance !== "undefined" && PopupService_1.PopupServiceInstance) === "function" ? _a : Object, typeof (_b = typeof client_1.NotifyServiceInstance !== "undefined" && client_1.NotifyServiceInstance) === "function" ? _b : Object])
], ConversationPreviewPage);
ConversationPreviewPage.defineComponent();
